import React from 'react';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { IconCtaLeftAlignedCard } from '@ahc-digital/component-library';
import { CreateIconCTALeftAlignedCardModel } from './C33IconCTALeftAligned.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C33IconCTALeftAlignedCardProps = RenderingProps<
  C33IconCTALeftAlignedCardFields,
  {
    TitleType?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams
>;

export type C33IconCTALeftAlignedCardFields = {
  Icon?: KeyValuePair;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CardCTA?: LinkField;
};

export const Default = (props?: C33IconCTALeftAlignedCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <IconCtaLeftAlignedCard
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      {...CreateIconCTALeftAlignedCardModel(props)}
      data-component={marketingRenderingName}
    />
  );
};
